import { render, staticRenderFns } from "./CargoCarrier.vue?vue&type=template&id=656b48f9&scoped=true&"
import script from "./CargoCarrier.vue?vue&type=script&lang=js&"
export * from "./CargoCarrier.vue?vue&type=script&lang=js&"
import style0 from "./CargoCarrier.vue?vue&type=style&index=0&id=656b48f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b48f9",
  null
  
)

/* custom blocks */
import block0 from "./CargoCarrier.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports